import {getTimeStamp} from './date';
import {cloneDeep} from 'lodash';

/**
 * 处理修改配置
 *
 * @param data 修改配置数据
 * @returns 返回处理后的教育修改配置对象
 */
export function handleEduAddConfig(data) {
    const eduAdConfig = {};

    for (const key in data) {
        const value = data[key];

        if (typeof value === 'string') {
            eduAdConfig[key] = value;
        }
        else if (value?.bgColor) {
            eduAdConfig[key] = null;
        }
        else if (value?.span || value?.color) {
            eduAdConfig[key] = value.span;
        }
    }

    return eduAdConfig;
}

/**
 * 处理教育程度更改信息的函数
 *
 * @param params - 包含图片路径和文本的参数对象
 * @param colorThemeMap - 颜色主题映射表
 * @param addition - 包含“支持更改”和“更改颜色”属性的对象
 * @returns 返回包含更改后的背景颜色和其他文本属性的对象
 */
export function handleEduChangeInfo(params, colorThemeMap, addition = {}) {
    const {colorTheme} = params;
    const {supportChange = 0, changedColor = []} = addition;

    const shouldChangeColor = supportChange && (changedColor.includes('any') || changedColor.includes(colorTheme));

    return {
        mainImg: params.mainImg,
        background: shouldChangeColor ? {
            bgColor: colorThemeMap?.[colorTheme]?.bgColor
        } : '',
        mainText: {
            span: params.mainText,
            color: shouldChangeColor ? colorThemeMap?.[colorTheme]?.mainTextColor : ''
        },
        descText: {
            span: params.descText,
            color: shouldChangeColor ? colorThemeMap?.[colorTheme]?.descTextColor : ''
        },
        otherText: {
            span: params.otherText,
            color: shouldChangeColor ? colorThemeMap?.[colorTheme]?.otherTextColor : ''
        },
        buttonText: {
            span: params.buttonText,
            color: shouldChangeColor ? colorThemeMap?.[colorTheme]?.buttonTextColor : ''
        },
        sellingPointFirst: {
            span: params.sellingPointFirst,
            color: shouldChangeColor ? colorThemeMap?.[colorTheme]?.sellingPointFirstColor : ''
        },
        sellingPointSecond: {
            span: params.sellingPointSecond,
            color: shouldChangeColor ? colorThemeMap?.[colorTheme]?.sellingPointSecondColor : ''
        },
        sellingPointThird: {
            span: params.sellingPointThird,
            color: shouldChangeColor ? colorThemeMap?.[colorTheme]?.sellingPointThirdColor : ''
        }
    };
}


/**
 * 教育配置
 *
 * @param params - 参数
 * @param colorThemeMap - 颜色主题映射
 * @param templateInfo - 模板信息
 * @returns {Array} - 教育广告配置列表
 */
export function productEduAdConfig(params, colorThemeMap, templateInfo) {
    const eduAdConfigList = [];
    const isB2B = params.isB2B;
    const needCutout = isB2B && params.name && params.name.includes('有抠图版本');
    const hasDescText = isB2B && params.descText && params.descText.length;

    templateInfo.forEach(templateInfoItem => {
        const {templateData: {layers, addition}} = templateInfoItem;
        const eduChangeInfo = handleEduChangeInfo(params, colorThemeMap, addition);

        if (!layers || !Array.isArray(layers) || !layers.length) {
            return;
        }

        const eduAdConfig = {};
        if (needCutout || !isB2B) {
            layers.forEach(item => {
                let itemType;
                let itemLabel;
                let nameArr = [item?.params?.[0]?.title];
                if (nameArr.includes('背景') && item.originType === 'background') {
                    itemLabel = 'background';
                    itemType = 'image';
                }
                else if (nameArr.includes('主体图') || nameArr.includes('产品图')) {
                    itemLabel = 'mainImg';
                    itemType = 'image';
                }
                else if (nameArr.includes('主标题')) {
                    itemLabel = 'mainText';
                    itemType = 'span';
                }
                else if (nameArr.includes('副标题')) {
                    itemLabel = 'descText';
                    itemType = 'span';
                }
                else if (nameArr.includes('其他文案')) {
                    itemLabel = 'otherText';
                    itemType = 'span';
                }
                else if (nameArr.includes('按钮文案')) {
                    itemLabel = 'buttonText';
                    itemType = 'span';
                }
                else if (nameArr.includes('卖点1')) {
                    itemLabel = 'sellingPointFirst';
                    itemType = 'span';
                }
                else if (nameArr.includes('卖点2')) {
                    itemLabel = 'sellingPointSecond';
                    itemType = 'span';
                }
                else if (nameArr.includes('卖点3')) {
                    itemLabel = 'sellingPointThird';
                    itemType = 'span';
                }
                if (itemType && itemLabel) {
                    const itemKey = `${item.key}.${itemType}`;
                    const itemCon = eduChangeInfo[itemLabel];
                    eduAdConfig[itemKey] = itemCon;
                }
            });
        }
        else {
            layers.forEach(item => {
                let itemType;
                let itemLabel;
                let nameArr = [item?.params?.[0]?.title];
                if ((nameArr.includes('背景') && item.originType === 'background')
                    || nameArr.includes('背景图')
                ) {
                    itemLabel = 'mainImg';
                    itemType = 'image';
                }
                else if (nameArr.includes('主标题')) {
                    itemLabel = 'mainText';
                    itemType = 'span';
                }
                else if (nameArr.includes('副标题')) {
                    itemLabel = 'descText';
                    itemType = 'span';
                }
                else if (nameArr.includes('卖点1')) {
                    itemLabel = 'sellingPointFirst';
                    itemType = 'span';
                }
                else if (nameArr.includes('卖点2')) {
                    itemLabel = 'sellingPointSecond';
                    itemType = 'span';
                }
                else if (nameArr.includes('卖点3')) {
                    itemLabel = 'sellingPointThird';
                    itemType = 'span';
                }
                if (itemType && itemLabel) {
                    const itemKey = `${item.key}.${itemType}`;
                    const itemCon = eduChangeInfo[itemLabel];
                    eduAdConfig[itemKey] = itemCon;
                }
            });
        }

        eduAdConfigList.push(eduAdConfig);
    });

    return eduAdConfigList;
}

/**
 * 处理慧图图片参数
 *
 * @param templateItem 模板项
 * @param adConfig 广告配置
 * @param layers 图层
 * @returns 返回包含慧图参数的对象
 */
export function handleHuituImageParams(templateItem, adConfig, layers) {
    const {templateData: {width, height}, id, imgTplType} = templateItem;

    // 提前拦截尺寸异常的合成请求，避免合成服务失败影响成功率
    if (!(width > 0 && height > 0)) {
        throw new Error('图片尺寸异常');
    }
    if (layers == null) {
        layers = templateItem.templateData.layers;
    }
    /**
     * 格式化参数，背景：layers里的params在进入编辑器后会被丢弃，
     * layer.name里的数据不规范的话，保存为模板后，只有layer.name，无法匹配到原本的主标题、副标题等图层名称
     * 将layer.params[0].title赋值给layer.name，保证私有模板中能保留原始参数
     */
    layers.forEach(layer => {
        if (layer.params && layer.params[0] && layer.params[0].title) {
            layer.name = layer.params[0].title;
        }
    });

    return {
        id,
        templateId: 0,
        productSource: 1,
        huituName: `图片工具-${getTimeStamp()}`,
        productLine: 'CHUANGYIGUAN',
        saveToMyHuitu: false,
        needMola: false,
        supportEdit: false,
        imgTplType,
        params: {
            adConfig,
            options: {
                result: {
                    imageType: 'jpeg',
                    type: 'URL'
                },
                waitUntil: 'domcontentloaded',
                viewport: {
                    imagetTimeout: 6000,
                    width,
                    height
                }
            },
            tplInfo: {
                data: {
                    width,
                    height,
                    layers
                },
                previewPlugins: ['legocomponents'],
                renderType: 'editor'
            }
        }
    };
}


/**
 * 处理编辑信息
 *
 * @param data 编辑信息数据
 * @returns 返回处理后的数据
 */
export function handleEditInfo(data) {
    const {url, width, height, templateData, duration} = data;
    const {params = {}, id = 0, imgTplType = '', editorType} = templateData;
    params.adConfig = {
        ...params.adConfig,
        width,
        height
    };

    return {
        id,
        taskId: 0,
        recordId: 0,
        url,
        width,
        height,
        imgTplType,
        ratio: 'RATIO_OTHER',
        imageId: 0,
        picId: 0,
        saveUrl: '',
        collect: 0,
        molaUrl: '',
        duration,
        editorParams: JSON.stringify({
            templateId: id,
            editorJson: JSON.stringify(params.adConfig),
            newEditorTplData: editorType === 'newEditor' ? JSON.stringify(templateData) : '{}',
            tplData: editorType === 'newEditor'
            ? JSON.stringify({templateData: {}, templateId: 0})
            : JSON.stringify({templateData: params.tplInfo.data, templateId: id})
        })
    };
}

/**
 * 处理保存信息
 *
 * @param {Object} data - 数据对象
 * @param {Object} params - 参数对象
 * @returns {Object} - 返回包含基础图片信息和生成列表的对象
 */
export function handleSaveInfo(data, params) {
    if (!data?.length) {
        return {};
    }
    const businessPoint = params.businessPoint || '';
    const imageGenerateType = params.imageGenerateType || 'MARKETING_IMAGE_MODEL';
    const originTargetCount = params.targetCount;
    // 超过一定数量的话，提交给后端的targetCount使用前端实际合成的结果数；避免大量合成图片时统计数据的失败率太低
    const targetCount = originTargetCount > 20 ? data.length : originTargetCount;
    return {
        basicImageInfo: {
            height: params.height,
            width: params.width,
            targetCount,
            imageGenerateType,
            businessPoint,
            imageSubject: params.mainImg || '',
            ext: JSON.stringify({
                originTargetCount,
                ...params.extraParams
            })
        },
        risk: true,
        generateList: data.map(item => {
            const ext = cloneDeep(params.extraParams);
            const {url, id, editorParams, imgTplType} = item;
            if (ext.dataAnalysis == null) {
                ext.dataAnalysis = {};
            }
            if (ext.dataAnalysis != null) {
                ext.dataAnalysis.imgTplType = imgTplType;
            }
            else {
                if (imgTplType) {
                    ext.dataAnalysis = {imgTplType};
                }
            }
            // 增加每张图的时长
            if (item.duration) {
                ext.dataAnalysis.duration = item.duration;
            }
            // 增加生成的目标数和实际数
            ext.dataAnalysis.originTargetCount = originTargetCount;
            ext.dataAnalysis.realCount = data.length;
            const json = JSON.parse(editorParams || '{}');
            const tplData = JSON.parse(json?.tplData || '{}');
            const {width = 0, height = 0} = tplData.templateData || {};
            return {
                url,
                templateId: id,
                generateJson: editorParams,
                width,
                height,
                ext: JSON.stringify(ext)
            };
        })
    };
}

/**
 * 把文案信息取出来，格式化成方便过风控的形式
 *
 * @param {Object} params - 参数对象
 * @returns {Array} - 返回文案列表
 */
export function formatTextFromLayerMap(params = {}) {
    let texts = [];
    for (let key in params) {
        let keyData = params[key] || {};
        if (keyData?.value && keyData.type === 'span') {
            texts.push(keyData?.value);
        }
    }
    return texts.filter((str, index) => (str && texts.indexOf(str) === index));
}